import { render } from "./AgregarProducto.vue?vue&type=template&id=a0537254"
import script from "./AgregarProducto.vue?vue&type=script&lang=js"
export * from "./AgregarProducto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__